import { render, staticRenderFns } from "./success.component.vue?vue&type=template&id=d5510108&scoped=true"
import script from "./success.component.vue?vue&type=script&lang=js"
export * from "./success.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5510108",
  null
  
)

export default component.exports